import React from "react";

export default function SQLServer_CEILING() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_CEILING</h1>
      <p>This is the SQLServer_CEILING component generated from the SQL JSON.</p>
    </div>
  );
}
